export default __webpack_public_path__ + "static/media/slide.f51283ea.png";